<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Parrainage'
});
</script>
<template>
  <ka-container
    code="parrainage"
    :data="page.$info.parrainage">
    <!-- Container de page -->
    <ka-container code="container-de-page">
      <ka-text code="titre">
        <h1 v-html="t('parrainage.containerDePage.titre.value', `Faites rayonner la pédagogie Matchers ! #parrainage `)" />
      </ka-text>
      <!-- Parrainer Matchers -->
      <ka-container code="parrainer-matchers">
        <!-- Ecrivez nous -->
        <ka-container code="ecrivez-nous">
          <ka-text code="sous-titre">
            <span v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.sousTitre.value', `Vous avez à y gagner !`)" />
          </ka-text>
          <!-- Conteneur 2 -->
          <ka-container code="conteneur-2">
            <ka-icon
              code="icone"
              value="i-fa-solid:credit-card" />
            <ka-text code="un-bon-dachat-de">
              <h3 v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.conteneur2.unBonDachatDe.value', `Un <span style='color:#D93174FF;'><strong>bon d'achat de 200€</strong></span> à valoir chez l'enseigne de votre choix !`)" />
            </ka-text>
          </ka-container>
          <ka-text code="ou">
            <h3 v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.ou.value', `OU`)" />
          </ka-text>
          <!-- Conteneur 2 -->
          <ka-container code="container-1">
            <ka-icon
              code="icon-1"
              value="i-fa-solid:hand-holding-heart" />
            <ka-text code="k-2-h-daccompagnement">
              <h3 v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.container1.k2HDaccompagnement.value', `2h d'accompagnement avec un expert Matchers.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur 2 -->
          <ka-container code="container-2">
            <ka-text code="visioconference-de">
              <h3 v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.container2.visioconferenceDe.value', `<i>Visioconférence de 2h sur l'une des thématiques suivantes : SEO, Google Ads, Google Analytics, Communication sur LinkedIn, Communication sur Facebook et Instagram, RH, Recrutement, Commerce & Vente, Organisation et Management. </i>`)" />
            </ka-text>
          </ka-container>
          <ka-text code="text-1">
            <span v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.text1.value', `Vous connaissez peut-être ? `)" />
          </ka-text>
          <ka-text code="une-startup-un-e-commercant">
            <span v-html="t('parrainage.containerDePage.parrainerMatchers.ecrivezNous.uneStartupUnECommercant.value', `Une startup, un e-commerçant ou un commerçant susceptible d'être intéressé par une formation Matchers ? `)" />
          </ka-text>
        </ka-container>
        <!-- Formulaire -->
        <ka-container code="formulaire">
          <ka-iframe
            code="iframe"
            :options="{
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              }
            }"
            value="https://share.hsforms.com/1fWn2CdhHR6O7Ys1McIatjg2xvix" />
        </ka-container>
      </ka-container>
      <ka-text
        code="comment-ca-marche"
        :options="{ click: page.commentCaMarcheClick }">
        <h2 v-html="t('parrainage.containerDePage.commentCaMarche.value', `Comment ça marche ?`)" />
      </ka-text>
      <!-- Etapes -->
      <ka-container
        code="etapes"
        :options="{ click: page.etapesClick }"
        inner>
        <!-- Etape 1 -->
        <ka-container code="etape-1">
          <ka-text code="text-2">
            <span v-html="t('parrainage.containerDePage.etapes.etape1.text2.value', `<strong>Étape 1</strong>`)" />
          </ka-text>
          <ka-text code="presentez-nous-la-personne">
            <span v-html="t('parrainage.containerDePage.etapes.etape1.presentezNousLaPersonne.value', `Présentez-nous la personne susceptible d'être intéressée.`)" />
          </ka-text>
        </ka-container>
        <!-- Etape 1 -->
        <ka-container code="container-3">
          <ka-text code="etape-2">
            <span v-html="t('parrainage.containerDePage.etapes.container3.etape2.value', `<strong>Étape 2</strong>`)" />
          </ka-text>
          <ka-text code="matchers-se-charge">
            <span v-html="t('parrainage.containerDePage.etapes.container3.matchersSeCharge.value', `Matchers se charge de prendre contact et d'étudier la faisabilité du dossier.`)" />
          </ka-text>
        </ka-container>
        <!-- Etape 1 -->
        <ka-container code="container-4">
          <ka-text code="etape-3">
            <span v-html="t('parrainage.containerDePage.etapes.container4.etape3.value', `<strong>Étape 3</strong>`)" />
          </ka-text>
          <ka-text code="votre-filleul-est-ok">
            <span v-html="t('parrainage.containerDePage.etapes.container4.votreFilleulEstOk.value', `Votre filleul est ok pour poursuivre avec nous ? Choisissez votre cadeau !`)" />
          </ka-text>
        </ka-container>
        <!-- Bar-horizontale -->
        <ka-container
          code="bar-horizontale"
          :xs="{ hidden: null }" />
      </ka-container>
      <!-- Conteneur -->
      <ka-container
        code="conteneur"
        inner>
        <!-- Textes -->
        <ka-container code="textes">
          <ka-text code="pourquoi-parrainer">
            <span v-html="t('parrainage.containerDePage.conteneur.textes.pourquoiParrainer.value', `Pourquoi parrainer Matchers ? `)" />
          </ka-text>
          <ka-text code="lorsque-vous-parrainez">
            <span v-html="t('parrainage.containerDePage.conteneur.textes.lorsqueVousParrainez.value', `Lorsque vous parrainez une entreprise vous contribuez à <strong>démocratiser la formation pour les petites entreprises</strong>. Grâce à votre recommandation, bien souvent elles vont découvrir leurs droits, bénéficier de notre accompagnement sans frais et pouvoir faire monter en compétences leurs équipes 🚀`)" />
          </ka-text>
        </ka-container>
        <!-- Boutons -->
        <ka-container code="boutons">
          <ka-button
            code="prendre-rendez-vous"
            :options="{
              ripple: true,
              href: `https://meetings.hubspot.com/christophe-pramil`,
              ariaLabel: `prendre rendez vous`,
              click: page.prendreRendezVousClick
            }">
            <span v-html="t('parrainage.containerDePage.conteneur.boutons.prendreRendezVous.value', `Contactez-nous`)" />
          </ka-button>
          <ka-button
            code="voir-faq"
            :options="{
              ripple: true,
              hidden: null
            }">
            <span v-html="t('parrainage.containerDePage.conteneur.boutons.voirFaq.value', `Voir la F.A.Q`)" />
          </ka-button>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { parrainage } from './store'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p19')
const appData = appDataStore()
const page = parrainage()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
